import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { checkIfHotjarEnable, timeBetweenDates } from '../utils/helpers';
import RimacTopBar from '../components/common/RimacTopBar/RimacTopBar';
import RimacFooter from '../components/common/RimacFooter/RimacFooter';
import ImgError from '../assets/images/img_errors.svg';
import Button from '../components/common/button/Button';
import { LINK_BBVA_SEGURO_TARJETAS, LINK_HOME_UTM } from '../utils/constants';

const errors = {
  404: {
    text: '¡Boo! Llegaste a una página fantasma',
    btnText: 'Ir al Home',
    btnLink: LINK_HOME_UTM
  },
  504: {
    text: 'Revisa tu correo electrónico, si no te llego el mensaje de confirmación de siniestro, por favor inténtalo nuevamente en 24 horas.',
    btnText: 'Volver a BBVA',
    btnLink: LINK_BBVA_SEGURO_TARJETAS
  },
  other: {
    text: 'Ocurrió un error inesperado, por favor vuelve a intentarlo más tarde. También puedes descargar de la web bbva.com.pe el formulario de atención de siniestros y enviarlo al correo de atención siniestrosprotecciondetarjeta@bbva.com',
    btnText: 'Ir al Home',
    btnLink: LINK_HOME_UTM
  },
};

const ErrorPage = ({ is404 }) => {
  const [viewStartTime] = useState(new Date());
  const [errorCode, setErrorCode] = useState();

  const globaErrorCode = useSelector((state) => state.coverages?.errorCode);

  useEffect(() => {
    if (checkIfHotjarEnable()) {
      if (is404) {
        setErrorCode(404);
        // LAST
        window.digitalData.push({
          "virtual": {
            "name": "web:tramites-siniestros:proteccion-tarjeta:pagina-fantasma"
          },
          "event": "trackVirtual"
        });
      } else {
        // LAST
        window.digitalData.push({
          virtual: {
            name: 'web:tramites-siniestros:proteccion-tarjeta:error',
          },
          event: 'trackVirtual',
        });
      }
    }
  }, [is404]);

  useEffect(() => {
    const endTime = new Date();
    const userTotalTime = timeBetweenDates(viewStartTime, endTime);

    if (checkIfHotjarEnable()) {
      // LAST
      window.digitalData.push({
        task: {
          name: 'Tiempo registrado - Error Page',
          time: userTotalTime,
        },
        event: 'trackTimeToComplete',
      });
    }
  }, [viewStartTime]);

  useEffect(() => {
    if (!globaErrorCode || globaErrorCode === -1) return;
    setErrorCode(globaErrorCode);
  }, [globaErrorCode]);

  const handleGoToHome = (e) => {
    if (checkIfHotjarEnable()) {
      if (is404) {
        // LAST
        window.digitalData.push({
          "action": {
            "group": "Tramites Siniestros - Protección Tarjeta BBVA",
            "category": "Reportar siniestro - página fantasma",
            "name": "click",
            "label": "Ir al home"
          },
          "event": "trackAction"
        });
      } else {
        if (errorCode) return;
        // LAST
        window.digitalData.push({
          "action": {
            "group": "Tramites Siniestros - Protección Tarjeta BBVA",
            "category": "Reportar siniestro - error500",
            "name": "click",
            "label": "Ir al home"
          },
          "event": "trackAction"
        });
      }
    }
  }

  return (
    <>
      <RimacTopBar phoneActive />
      <div className="loadingPage">
        <section className="loadingPage__cont">
          <img
            className="loadingPage__imgError"
            src={ImgError}
            alt="Rimac Error"
          />
          <h1 style={{maxWidth: '615px', textAlign: 'center'}} className=" u-mb-64">
            {errors[errorCode || 'other'].text}
          </h1>
          <Button primary>
            <a href={errors[errorCode || 'other'].btnLink} className="link" onClick={handleGoToHome}>
              {errors[errorCode || 'other'].btnText}
            </a>
          </Button>
        </section>
      </div>
      <RimacFooter isAppInfoActive={false} />
    </>
  );
};

export default ErrorPage;
